import { useState } from 'react';

function useForm(initValues = {}) {
  const [values, setValues] = useState(initValues);

  const handleChange = (name) => (e) => {
    setValues({ ...values, [name]: e.target.value });
  };

  const handleChangeNumber = (name) => (e) => {
    if (e.target.value === '' || /^[0-9\b]+$/.test(e.target.value)) {
      setValues({ ...values, [name]: e.target.value });
    }
  };

  const setFieldValue = (name, val) => setValues({ ...values, [name]: val });
  const setFieldValues = (val) => setValues({ ...values, ...val });
  const handleReset = () => setValues({});

  return {
    values,
    handleChange,
    handleChangeNumber,
    handleReset,
    setFieldValue,
    setFieldValues,
  };
}

export default useForm;
